import { API } from '../../../common/api/constants';

// CRUD

// ПОЛУЧИТЬ ВСЕ ТС GET
export const GET_ALL_VEHICLES = `${API}/transport/vehicle/profile/{profile_id}`;
// ПОЛУЧИТЬ ВСЕ ТС ПО ФИЛЬТРУ GET
export const GET_FILTER_VEHICLES = `${API}/transport/vehicles/filter/{profile_id}`;
// Получить все ТС по KEY Статуса ТС
export const GET_VEHICLES_BY_STATUS = `${API}/transport/vehicle/status/key/`;
// ПОЛУЧИТЬ ТС ПО ID GET
export const GET_VEHICLE = `${API}/transport/vehicle/{id}/profile_carrier/{profile_id}`;
// ОБНОВИТЬ ТРАНСПОРТНОЕ СРЕДСТВО ПО ID С ПРОВЕРКОЙ ПО ID ПРОФИЛЯ
export const UPDATE_VEHICLE = `${API}/transport/vehicle/{vehicle_id}/profile/{profile_id}`;
// СОЗДАТЬ ТРАНСПОРТНОЕ СРЕДСТВО
export const CREATE_VEHICLE = `${API}/transport/vehicle/profile/{profile_id}`;
// ПОЛУЧЕНИЕ ПОЛЕЙ МУЛЬТИСЕЛЕКТОВ
export const BRANDS_GET = `${API}/transport/vehicle/brands`; // все бренды
export const MODELS_GET = `${API}/transport/vehicle/models`; //Получить все Модели ТС
export const VEHICLE_TYPES = `${API}/transport/vehicle_types`; //Получить все Типы ТС
export const CATEGORIES_GET = `${API}/transport/vehicle_categories`; //все категории
export const COLORS_GET = `${API}/transport/vehicle_colors`; //все цвета
export const TACHOGRAPHS_GET = `${API}/transport/tachographs`; // Получить все Тахографы
export const CONDITIONERS_GET = `${API}/transport/vehicle_conditioners`; // Получить все Типы Кондиционеров
export const DRIVE_TYPES_GET = `${API}/transport/vehicle_drive_unit_types`; // Получить все Типы Приводов
export const ENGINE_TYPES_GET = `${API}/transport/vehicle_engine_types`; // Получить все Типы Двигателя
export const TINTS_GET = `${API}/transport/vehicle_tints`; // Получить все Тонировки Стекол
export const PARKING_ADDRESSES_GET = `${API}/transport/vehicle_parking_addresses`; // Получить все Адреса Стоянок/Гаражей
export const SEAT_MATERIALS_GET = `${API}/transport/vehicle_seat_materials`; //Получить все Материалы Сидений
export const FUNCTIONS_GET = `${API}/transport/functions`; //Получить все Назначения ТС
export const TRANSFERS_GET = `${API}/transport/transfer_preparations`; //Получить все Подготовки для Трансферов/Экскурсий
export const INTERIORS_GET = `${API}/transport/interior_components`; //Получить все Компоненты Салона
export const FACILITIES_GET = `${API}/transport/facilities`; //Получить всю Бытовую Технику
export const ENTERTAINMENTS_GET = `${API}/transport/entertainments`; //Получить все Развлечения
export const APPLIANCES_GET = `${API}/transport/appliances`; //Получить все типы Дополнительного Оборудования
export const ADVERTISINGS_GET = `${API}/transport/advertisings`; //Получить все типы Реклам
export const PARKING_GET = `${API}/transport/vehicle_parking_addresses`; //Получить адреса парковок
export const MODELS_BY_BRAND_GET = `${API}/transport/vehicle/model/brand/`; // Получить Модели ТС по ID Бренда ТС
export const MODELS_BY_KEYS_BRANDS_GET = `${API}/transport/vehicle/model/brands`; // Получить Марки ТС по списку КЛЮЧЕЙ БРЕНДОВ
export const STEERING_ARRANGEMENT_GET = `${API}/transport/vehicle_steering_arrangements`; // Получить все Расположения Руля
export const DRIVE_UNIT_TYPES_GET = `${API}/transport/vehicle_drive_unit_types`; // Получить все Типы Приводов

// export const ENGINE_TYPES_GET = `${API}/transport/vehicle_engine_types`; // Получить все Типы Двигателя
// export const ENGINE_TYPES_GET = `${API}/transport/vehicle_engine_types`; // Получить все Типы Двигателя
// export const ENGINE_TYPES_GET = `${API}/transport/vehicle_engine_types`; // Получить все Типы Двигателя

export const USER_FILTER_VEHICLES_GET = `${API}/transport/vehicles/filter`; // Получить ТС по фильтру (USER)
export const USER_SEARCH_VEHICLES_GET = `${API}/transport/vehicles/search`; // Полнотекстовый поиск ТС (ADMIN)

export const UPLOAD_VEHICLE_PHOTOS = `${API}/utility/image/upload/vehicle_photos`;
export const UPLOAD_VEHICLE_STS_FRONT = `${API}/utility/image/upload/vehicle_sts_front`;
export const UPLOAD_VEHICLE_PTS_FRONT = `${API}/utility/image/upload/vehicle_pts_front`;
export const UPLOAD_VEHICLE_STS_BACK = `${API}/utility/image/upload/vehicle_sts_back`;
export const UPLOAD_VEHICLE_PTS_BACK = `${API}/utility/image/upload/vehicle_pts_back`;

// Поиск по рег номеру
export const AUTO_SEARCH_BY_NUM = `${API}/utility/avtocod/vehicle/report/`; // GET
